import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";

const MdlEditEventParticipant = ({ 
  show, 
  onClose, 
  participant,
  event_id, 
  session_id,
  participantGroups = [],
  onSuccess 
}) => {
  const [saving, setSaving] = useState(false);
  const [eventClasses, setEventClasses] = useState([]);
  const [formData, setFormData] = useState({
    student_name: "",
    student_dob: "",
    gender: "",
    community: "",
    religion: "",
    nationality: "",
    current_school_name: "",
    board_id: "",
    medium_id: "",
    reading_class: "",
    reading_class_id: "",
    student_aadhar: "",
    mother_name: "",
    father_name: "",
    contact_number: "",
    whatsapp_number: "",
    address: "",
    remark: "",
    group_id: "",
    participanting_class_id: "",
  });

  // Fetch event classes when modal opens
  useEffect(() => {
    if (show && event_id && session_id) {
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getEventClasses.php`;
      
      axios.get(URL, {
        params: {
          event_id: event_id,
          session_id: session_id,
          school_code: SCHOOL_CODE,
        }
      })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK" && Array.isArray(response.data)) {
          setEventClasses(response.data || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching event classes:", error);
      });
    }
  }, [show, event_id, session_id]);

  useEffect(() => {
    if (show && participant) {
      setFormData({
        student_name: participant.student_name || "",
        student_dob: participant.student_dob || "",
        gender: participant.gender || "",
        community: participant.community || "",
        religion: participant.religion || "",
        nationality: participant.nationality || "",
        current_school_name: participant.current_school_name || "",
        board_id: participant.board_id || "",
        medium_id: participant.medium_id || "",
        reading_class: participant.reading_class || "",
        reading_class_id: participant.reading_class_id || "",
        student_aadhar: participant.student_aadhar || "",
        mother_name: participant.mother_name || "",
        father_name: participant.father_name || "",
        contact_number: participant.contact_number || "",
        whatsapp_number: participant.whatsapp_number || "",
        address: participant.address || "",
        remark: participant.remark || "",
        group_id: participant.group_id || "",
        participanting_class_id: participant.participanting_class_id || "",
      });
    } else if (!show) {
      // Reset form when modal closes
      setFormData({
        student_name: "",
        student_dob: "",
        gender: "",
        community: "",
        religion: "",
        nationality: "",
        current_school_name: "",
        board_id: "",
        medium_id: "",
        reading_class: "",
        reading_class_id: "",
        student_aadhar: "",
        mother_name: "",
        father_name: "",
        contact_number: "",
        whatsapp_number: "",
        address: "",
        remark: "",
        group_id: "",
        participanting_class_id: "",
      });
    }
  }, [show, participant]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.student_name.trim()) {
      myToast.notify_warning("Please enter student name");
      return;
    }
    
    if (!formData.father_name.trim()) {
      myToast.notify_warning("Please enter father name");
      return;
    }
    
    if (!formData.contact_number.trim()) {
      myToast.notify_warning("Please enter contact number");
      return;
    }

    if (!participant || !participant.paricipant_id) {
      myToast.notify_error("Participant information not found");
      return;
    }

    setSaving(true);
    try {
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const URL =
        process.env.REACT_APP_SERVER_NAME +
        process.env.REACT_APP_TARGET_DIR +
        "UpdateEventParticipant.php";

      const params = {
        participant_id: participant.paricipant_id,
        event_id: event_id,
        session_id: session_id,
        student_name: formData.student_name.trim(),
        student_dob: formData.student_dob || "",
        gender: formData.gender || "",
        community: formData.community || "",
        religion: formData.religion || "",
        nationality: formData.nationality || "",
        current_school_name: formData.current_school_name || "",
        board_id: formData.board_id || "",
        medium_id: formData.medium_id || "",
        reading_class: formData.reading_class || "",
        reading_class_id: formData.reading_class_id || "",
        student_aadhar: formData.student_aadhar || "",
        mother_name: formData.mother_name || "",
        father_name: formData.father_name.trim(),
        contact_number: formData.contact_number.trim(),
        whatsapp_number: formData.whatsapp_number || formData.contact_number.trim(),
        address: formData.address || "",
        remark: formData.remark || "",
        group_id: formData.group_id || "",
        participanting_class_id: formData.participanting_class_id || "",
        school_code: SCHOOL_CODE,
      };

      const response = await axios.get(URL, { params });

      if (response.data.api_status === "OK") {
        myToast.notify_success("Participant updated successfully");
        onClose();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        myToast.notify_warning(response.data.api_remark || "Failed to update participant");
      }
    } catch (error) {
      console.error("Error updating participant:", error);
      myToast.notify_error("Error updating participant: " + (error.response?.data?.api_remark || error.message));
    } finally {
      setSaving(false);
    }
  };

  // Always render the modal, but only show when both conditions are met
  return (
    <>
      <style>{`
        .participant-modal .modal-content {
          border: none;
          border-radius: 12px;
          overflow: hidden;
          background: transparent;
          box-shadow: 0 18px 40px rgba(15,23,42,0.28);
        }
        .participant-modal .modal-header {
          border-radius: 12px 12px 0 0;
          overflow: hidden;
        }
        .participant-modal .modal-body {
          border-radius: 0;
        }
        .participant-modal .modal-footer {
          border-radius: 0 0 12px 12px;
          overflow: hidden;
        }
      `}</style>
      <Modal
        show={show && !!participant}
        onHide={onClose}
        size="lg"
        centered
        backdrop={true}
        keyboard={true}
        dialogClassName="participant-modal"
        animation={false}
      >
      <Modal.Header
        closeButton={false}
        style={{
          background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
          color: "#fff",
          borderBottom: "none",
          borderRadius: "12px 12px 0 0",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(255,255,255,0.12)", display: "grid", placeItems: "center" }}>
            <i className="fa fa-edit" style={{ color: "#fff", fontSize: 16 }} />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 16 }}>Edit Participant</div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>
              {participant?.student_name || "Update Information"}
            </div>
          </div>
        </div>
        <button
          type="button"
          className="close"
          onClick={onClose}
          style={{ color: "#fff", opacity: 1, fontSize: 24, lineHeight: 1, background: "transparent", border: "none", padding: "4px 8px" }}
        >
          <span>&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: "0", maxHeight: "70vh", overflowY: "auto", background: "#f8fafc", borderRadius: "0 0 12px 12px" }}>
        <form onSubmit={handleSubmit} style={{ padding: "16px" }}>
          {/* Student Information Section */}
          <div style={{ 
            background: `linear-gradient(180deg, ${COLORS.primary_color_shade1 || "#eef2ff"} 0%, #ffffff 65%)`, 
            borderRadius: "10px", 
            padding: "12px 14px", 
            marginBottom: "12px",
            boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
            border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12, fontWeight: 700, color: COLORS.primary_color_shade7 || "#1d4ed8", fontSize: "13px" }}>
              <i className="fa fa-user-graduate" style={{ fontSize: "14px" }} />
              <span>Student Information</span>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: COLORS.primary_color_shade7 || "#1d4ed8", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Student Name <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="student_name"
                    value={formData.student_name}
                    onChange={handleInputChange}
                    required
                    style={{
                      borderRadius: "6px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`,
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                      e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade3 || "#c7d2fe";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: COLORS.primary_color_shade7 || "#1d4ed8", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="student_dob"
                    value={formData.student_dob}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`,
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                      e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade3 || "#c7d2fe";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Personal Details Section */}
          <div style={{ 
            background: `linear-gradient(180deg, ${COLORS.primary_color_shade1 || "#eef2ff"} 0%, #ffffff 65%)`, 
            borderRadius: "10px", 
            padding: "12px 14px", 
            marginBottom: "12px",
            boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
            border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12, fontWeight: 700, color: COLORS.primary_color_shade7 || "#1d4ed8", fontSize: "13px" }}>
              <i className="fa fa-id-card" style={{ fontSize: "14px" }} />
              <span>Personal Details</span>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: COLORS.primary_color_shade7 || "#1d4ed8", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Gender
                  </label>
                  <select
                    className="form-control"
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`,
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                      e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade3 || "#c7d2fe";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: COLORS.primary_color_shade7 || "#1d4ed8", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Community
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="community"
                    value={formData.community}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`,
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                      e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade3 || "#c7d2fe";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: COLORS.primary_color_shade7 || "#1d4ed8", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Religion
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="religion"
                    value={formData.religion}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`,
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                      e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade3 || "#c7d2fe";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: COLORS.primary_color_shade7 || "#1d4ed8", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Nationality
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="nationality"
                    value={formData.nationality}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`,
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                      e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade3 || "#c7d2fe";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: COLORS.primary_color_shade7 || "#1d4ed8", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Current School Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="current_school_name"
                    value={formData.current_school_name}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`,
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                      e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade3 || "#c7d2fe";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: COLORS.primary_color_shade7 || "#1d4ed8", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Reading Class
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="reading_class"
                    value={formData.reading_class}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#c7d2fe"}`,
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                      e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = COLORS.primary_color_shade3 || "#c7d2fe";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Group & Class Assignment Section */}
          <div style={{ 
            background: "linear-gradient(180deg, #f0fdf4 0%, #ffffff 65%)", 
            borderRadius: "10px", 
            padding: "12px 14px", 
            marginBottom: "12px",
            boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
            border: "1px solid #86efac"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12, fontWeight: 700, color: "#166534", fontSize: "13px" }}>
              <i className="fa fa-users-cog" style={{ fontSize: "14px" }} />
              <span>Group & Class Assignment</span>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: "#166534", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Group
                  </label>
                  <select
                    className="form-control"
                    name="group_id"
                    value={formData.group_id}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #86efac",
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#22c55e";
                      e.target.style.boxShadow = "0 0 0 2px rgba(34, 197, 94, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#86efac";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    <option value="">Select Group</option>
                    {participantGroups.map((group) => (
                      <option key={group.group_id} value={group.group_id}>
                        {group.group_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: "#166534", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Participant Class
                  </label>
                  <select
                    className="form-control"
                    name="participanting_class_id"
                    value={formData.participanting_class_id}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #86efac",
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#22c55e";
                      e.target.style.boxShadow = "0 0 0 2px rgba(34, 197, 94, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#86efac";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    <option value="">Select Class</option>
                    {eventClasses.map((eventClass) => (
                      <option key={eventClass.class_id} value={eventClass.class_id}>
                        {eventClass.class_name || eventClass.participanting_class_name || "N/A"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Family & Contact Information Section */}
          <div style={{ 
            background: "linear-gradient(180deg, #fff7ed 0%, #ffffff 65%)", 
            borderRadius: "10px", 
            padding: "12px 14px", 
            marginBottom: "12px",
            boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
            border: "1px solid #fde68a"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12, fontWeight: 700, color: "#92400e", fontSize: "13px" }}>
              <i className="fa fa-users" style={{ fontSize: "14px" }} />
              <span>Family & Contact Information</span>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: "#92400e", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Father Name <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="father_name"
                    value={formData.father_name}
                    onChange={handleInputChange}
                    required
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #fde68a",
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#f59e0b";
                      e.target.style.boxShadow = "0 0 0 2px rgba(245, 158, 11, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#fde68a";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: "#92400e", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Mother Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="mother_name"
                    value={formData.mother_name}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #fde68a",
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#f59e0b";
                      e.target.style.boxShadow = "0 0 0 2px rgba(245, 158, 11, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#fde68a";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: "#92400e", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    Contact Number <span style={{ color: "#ef4444" }}>*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    name="contact_number"
                    value={formData.contact_number}
                    onChange={handleInputChange}
                    required
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #fde68a",
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#f59e0b";
                      e.target.style.boxShadow = "0 0 0 2px rgba(245, 158, 11, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#fde68a";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ marginBottom: "12px" }}>
                  <label style={{ 
                    fontSize: "11px", 
                    fontWeight: 700, 
                    color: "#92400e", 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    display: "block"
                  }}>
                    WhatsApp Number
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    name="whatsapp_number"
                    value={formData.whatsapp_number}
                    onChange={handleInputChange}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #fde68a",
                      padding: "8px 10px",
                      fontSize: "13px",
                      transition: "all 0.2s ease",
                      background: "#fff"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#f59e0b";
                      e.target.style.boxShadow = "0 0 0 2px rgba(245, 158, 11, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#fde68a";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Additional Information Section */}
          <div style={{ 
            background: "#ffffff", 
            borderRadius: "10px", 
            padding: "12px 14px", 
            marginBottom: "12px",
            boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
            border: "1px solid #e5e7eb"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12, fontWeight: 700, color: "#374151", fontSize: "13px" }}>
              <i className="fa fa-info-circle" style={{ fontSize: "14px" }} />
              <span>Additional Information</span>
            </div>
            <div className="form-group" style={{ marginBottom: "12px" }}>
              <label style={{ 
                fontSize: "11px", 
                fontWeight: 700, 
                color: "#374151", 
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: "6px",
                display: "block"
              }}>
                Address
              </label>
              <textarea
                className="form-control"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                rows="2"
                style={{
                  borderRadius: "6px",
                  border: "1px solid #e5e7eb",
                  padding: "8px 10px",
                  fontSize: "13px",
                  transition: "all 0.2s ease",
                  background: "#fff",
                  resize: "vertical"
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                  e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>

            <div className="form-group" style={{ marginBottom: "0" }}>
              <label style={{ 
                fontSize: "11px", 
                fontWeight: 700, 
                color: "#374151", 
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: "6px",
                display: "block"
              }}>
                Remark
              </label>
              <textarea
                className="form-control"
                name="remark"
                value={formData.remark}
                onChange={handleInputChange}
                rows="2"
                style={{
                  borderRadius: "6px",
                  border: "1px solid #e5e7eb",
                  padding: "8px 10px",
                  fontSize: "13px",
                  transition: "all 0.2s ease",
                  background: "#fff",
                  resize: "vertical"
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                  e.target.style.boxShadow = `0 0 0 2px ${COLORS.primary_color_shade1 || "#eef2ff"}`;
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer
        style={{
          borderTop: "1px solid #e5e7eb",
          padding: "12px 16px",
          borderRadius: "0 0 12px 12px",
          overflow: "hidden",
          background: "#f8fafc",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px"
        }}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            padding: "8px 16px",
            borderRadius: "6px",
            border: "1px solid #d1d5db",
            background: "#fff",
            color: "#374151",
            fontWeight: 600,
            fontSize: "13px",
            cursor: "pointer",
            transition: "all 0.2s ease",
            display: "flex",
            alignItems: "center",
            gap: "6px"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#f9fafb";
            e.currentTarget.style.borderColor = "#9ca3af";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#fff";
            e.currentTarget.style.borderColor = "#d1d5db";
          }}
        >
          <i className="fa fa-times" style={{ fontSize: "12px" }} />
          Cancel
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={saving}
          style={{
            padding: "8px 20px",
            borderRadius: "6px",
            border: "none",
            background: saving 
              ? "#9ca3af" 
              : `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
            color: "#fff",
            fontWeight: 700,
            fontSize: "13px",
            cursor: saving ? "not-allowed" : "pointer",
            transition: "all 0.2s ease",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            boxShadow: saving ? "none" : "0 2px 8px rgba(59, 130, 246, 0.3)"
          }}
          onMouseEnter={(e) => {
            if (!saving) {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.4)";
            }
          }}
          onMouseLeave={(e) => {
            if (!saving) {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(59, 130, 246, 0.3)";
            }
          }}
        >
          {saving ? (
            <>
              <i className="fa fa-spinner fa-spin" style={{ fontSize: "12px" }} />
              Updating...
            </>
          ) : (
            <>
              <i className="fa fa-save" style={{ fontSize: "12px" }} />
              Update Participant
            </>
          )}
        </button>
      </Modal.Footer>
      </Modal>
    </>
  );
};

export default MdlEditEventParticipant;

